import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from '../../../../generic-components/Heading';
import { STYLE, TEXT } from '../../constants';

const { PAGES: { POST_LINKED: { MONEY_TRANSFER: pageStyles } } } = STYLE;

const { PAGES: { POST_LINKED: { MONEY_TRANSFER: pageContent } } } = TEXT;

interface IProps {
    accountInfo: string;
}

export const TransferHead = ({ accountInfo }: IProps) => {
  const { t } = useTranslation();
  return (
    <div className={pageStyles.HEAD.WRAPPER}>
      <Heading title={t(pageContent.HEAD.HEADING)} className={pageStyles.HEAD.SECTION_HEAD} />
      <Heading title={accountInfo} className={pageStyles.HEAD.SECTION_INFO} />
    </div>
  );
};
